<template>
	<div class="full-height">
		<Header ref="menus"></Header>

		<div class="flex-center">
			<div class="main-container" ref="main">
				<div class="nav-bar">
					<span>
						当前位置：
						<a href="/">首页</a>
						<span> > </span>
						<a href="/notice">通知公告</a>
					</span>
				</div>

				<div class="flex" style="min-height: 765px;justify-content: center;width: 100%;">
					<div class="text-overflow-hidden detail-container flex" style="width: 100%;">

						<div class="full-width" style="margin-right: 50px;">
							<h1 class="art-title">{{data.title}}</h1>
							<p class="art-time">{{deteFormat(new Date(data.publishTime), "yyyy.MM.dd hh:mm:ss")}}</p>
							<span class="art-pv" style="float: right;">浏览：{{data.pv}}次</span>


							<div class="art-content" v-html="data.content">

							</div>
							<p class="art-remark">
								<span style="float: left;">来源：{{data.origin}}</span>
								<span style="float: right;">作者：{{data.author}}</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<Footer>
		</Footer>
	</div>
</template>

<script>
	import Header from '../../components/Header';
	import Footer from '../../components/Footer';
	import api from '../../http/notice'
	import {
		formatTimeToStr
	} from '../../utils/date.js'
	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {
				nowMenuId: null,
				menus: {
					children: null
				},
				data: {},
				allMenus: []

			}
		},
		methods: {
			getData(id) {
				const _this = this;
				api.getDetail(id).then(res => {
					_this.data = res;
				})
			},
			deteFormat(date, formatter) {
				return formatTimeToStr(date, formatter);
			},
		},
		created() {
			var query = this.$route.query;
			this.getData(query.id);
		},
		mounted() {
			this.$refs.main.scrollIntoView()
		}
	}
</script>

<style scoped>
	.main-container {
		width: 1200px;
	}

	.nav-bar {
		text-align: left;
		width: 100%;
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		margin: 23px 0;
	}

	.detail-container {
		margin: 23px 0 30px 30px;
		padding-right: 50pxs;
		width: 100%;
	}

	.menu-container {
		margin-right: 30px;
		background: #F7F7F7;
		height: fit-content;
	}

	.menu-item-container {
		width: 166px;
		height: 55px;
		color: #666666;
	}

	.menu-item-icontainer-active {
		background: #A10000;
		color: #FFFFFF !important;
	}

	.calendar {
		width: 110px;
		height: 98px;
		background-image: url("/static/img/icon/calendar.png");
		background-size: cover;
		margin-right: 10px;
	}

	.title {
		height: 21px;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 20px;
	}

	.simple-content {
		margin-top: 16px;
		height: 17px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 16px;
	}

	.info-container {
		height: 100px;
	}

	.calendar-date {
		font-size: 20px;
		font-weight: bold;
	}

	.calendar-year {
		font-size: 18px;
		margin-top: 5px;
	}

	.art-title {
		height: 21px;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #333333;
		line-height: 21px;
	}

	.art-time {
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
		line-height: 16px;
		margin-top: 28px;
	}

	.art-pv {
		margin-top: -16px;
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
		line-height: 16px;
	}

	.art-content {
		margin-top: 25px;
		text-align: left;
		word-wrap: break-word;
		white-space: pre-wrap;
	}
	.art-content >>> img{
		max-width: 924px !important;
	}

	.art-remark {
		margin-top: 25px;
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
		line-height: 16px;
	}
</style>



// WEBPACK FOOTER //
// src/views/notice/detail.vue